export class ServiceRequest {


}
